import styles from '../Onboarding.module.css';
import { t } from '@/i18n';


export function WaitingApprovalStep() {
    return (
        <div className={styles.successContainer}>
            <h2 className={styles.title}>{t('onboarding.waitingApproval.title')}</h2>
            <p className={styles.subtitle}>{t('onboarding.waitingApproval.line1')}</p>
            <p className={styles.subtitle}>{t('onboarding.waitingApproval.line2')}</p>
        </div>
    );
}
